import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "select", "results"]
  
  connect() {
    this.results = []
    this.selectedCustomerId = null
    
    // Close results when clicking outside
    document.addEventListener("click", this.handleClickOutside.bind(this))
  }
  
  disconnect() {
    document.removeEventListener("click", this.handleClickOutside.bind(this))
  }
  
  search() {
    const query = this.inputTarget.value.toLowerCase()
    if (query.length < 2) {
      this.hideResults()
      return
    }
    
    const options = Array.from(this.selectTarget.options)
    this.results = options
      .filter(option => option.text.toLowerCase().includes(query))
      .slice(0, 10)
    
    this.showResults()
  }
  
  showResults() {
    this.resultsTarget.innerHTML = this.results
      .map(result => `
        <div class="p-2 hover:bg-gray-100 cursor-pointer"
             data-action="click->customer-search#select"
             data-customer-id="${result.value}">
          ${result.text}
        </div>
      `)
      .join('')
    
    this.resultsTarget.classList.remove('hidden')
  }
  
  hideResults() {
    this.resultsTarget.classList.add('hidden')
  }
  
  select(event) {
    const customerId = event.currentTarget.dataset.customerId
    const customerName = event.currentTarget.textContent.trim()
    
    this.inputTarget.value = customerName
    this.selectTarget.value = customerId
    this.hideResults()
  }
  
  handleClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.hideResults()
    }
  }
}
